import { Component, Prop, h } from '@stencil/core';

@Component({
    tag: 'sew-ws-whatsapp-service',
    styleUrl: 'sew-ws-whatsapp-service.scss',
    shadow: true,
})
export class SewWsWhatsappService {
    @Prop() headline: string;
    @Prop() items: any;

    render() {
        return (
            <div>
                {this.headline && <h3 class="headline">{this.headline}</h3>}
                {this.items.map((item, index) => {
                    return (
                        <div class={{ intro: index === 0, step: index > 0, split: item.img }}>
                            {item.img && (
                                <sew-picture
                                    img-src={item.img.src}
                                    img-alt={item.img.alt}
                                    img-title={item.img.title}
                                ></sew-picture>
                            )}
                            <span innerHTML={item.text}></span>
                        </div>
                    );
                })}
            </div>
        );
    }
}
